"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var cloneDependencies = exports.cloneDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createClone: _factoriesAny.createClone
};